import {useCallback,useRef,useState} from "react";
import {api,type MaintenanceType} from "./api";
import {useLiveRefresh} from "./use-live-refresh";

// Tipos de manutenção sempre atualizados: um tipo criado em "Gerenciar tipos" em outro computador
// aparece no PM sem recarregar a página (a cada 5 s com a página visível, ao voltar para a aba e
// ao abrir o seletor de tipo).
export function useMaintenanceTypes(onError:(message:string)=>void){
  const [types,setTypes]=useState<MaintenanceType[]>([]);
  const reported=useRef(false);
  const onErrorRef=useRef(onError);
  onErrorRef.current=onError;
  const refresh=useCallback(async()=>{
    try{
      setTypes(await api.maintenanceTypes());
      reported.current=false;
    }catch(error){
      // Falha momentânea na atualização automática avisa só uma vez, sem repetir a cada ciclo.
      if(!reported.current)onErrorRef.current((error as Error).message);
      reported.current=true;
    }
  },[]);
  useLiveRefresh(refresh,"maintenance-types");
  return {types,refresh};
}
